'use client';

import { useMediaQuery } from './media-query';

export function usePrefersReducedMotion() {
  return useMediaQuery('(prefers-reduced-motion)');
}
